import { featureFlags } from '@seen/core/featureFlags'
import { useEffect } from 'react'
import { setDemoModeAndReload } from '#src/demo-mode/installDemoMode.ts'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export function useDemoMode(): boolean {
  const stored = usePortalStore((state) => state.demoMode)
  const enabled = useFeatureFlag(featureFlags.demoMode)
  return stored && enabled
}

// Turns a stored Demo mode off (and reloads) once the flag is off, so a user
// cannot stay redacted with the switch hidden. Mount it only where the flag
// values are loaded, i.e. behind sign-in.
export function useDemoModeFlagGuard(): void {
  const stored = usePortalStore((state) => state.demoMode)
  const enabled = useFeatureFlag(featureFlags.demoMode)
  useEffect(() => {
    if (stored && !enabled) {
      setDemoModeAndReload(false)
    }
  }, [stored, enabled])
}
